module.exports = __webpack_public_path__ + "static/media/maze.90ef4493.webp";